import { useQuery } from "@tanstack/react-query";
import { useRouter } from "next/router";

import { autoCompleteProduct, getPosProduct, getPosProductVariations, getPosProducts } from "../../core/product.core";

export function usePosProducts() {
  const { isReady, locale } = useRouter();

  return useQuery({
    enabled: isReady,
    queryFn: () => getPosProducts(),
    queryKey: ["posProducts", locale],
  });
}

export function usePosProductById(id: string) {
  const { isReady, locale } = useRouter();

  return useQuery({
    enabled: ["string", "number"].includes(typeof id) && isReady,
    queryFn: () => getPosProduct(id),
    queryKey: ["posProduct", id, locale],
  });
}

export function useProductVariations(parentId: string) {
  const { isReady, locale } = useRouter();

  return useQuery({
    enabled: isReady && !!parentId,
    queryFn: () => getPosProductVariations(parentId),
    queryKey: ["productVarations", parentId, locale],
  });
}

export function useAutoCompleteProduct(search: string, delay: number) {
  const { isReady } = useRouter();

  return useQuery({
    enabled: isReady,
    queryFn: () => autoCompleteProduct(search),
    queryKey: ["posProducts", "productAutoComplete", delay],
  });
}
